export default function securitys(state = [], action) {
  switch (action.type) {
    case 'ADD_CURRENT':
      return {
        ...state,
        security: action.security,
      }
    default:
      return state;
  }
}
